module.exports = "<div uib-timepicker\r\n     ng-model=\"$ctrl.ngModel\"\r\n     show-spinners=\"false\"\r\n     show-meridian=\"$ctrl.showMeridian\">\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-timepicker/rw-timepicker.html
// module id = 2047
// module chunks = 0